import { BannerLandscape } from '.';
import { BannerHeroSkeleton } from '../bannerHero';
import React, { useEffect } from 'react';
import { useLazyGetPageBannersQuery } from 'features/api/promoEngineApiSlice';
import { isServerSide } from 'utility/constant';
import { useRouter } from 'next/router';

export const BannerLandscapeWrapper = ({
  pageId,
  showLoader,
  promoNumber,
  removePaddingLeft,
  removePaddingRight,
}: {
  pageId: string;
  showLoader: boolean;
  promoNumber: number;
  removePaddingLeft?: boolean;
  removePaddingRight?: boolean;
}) => {
  const { asPath } = useRouter();
  const [getPromo, { data, isLoading }] = useLazyGetPageBannersQuery();
  const banner = Reflect.get(data?.pageBannerList ?? {}, promoNumber) ?? undefined;

  useEffect(() => {
    if (isServerSide) return;
    getPromo(pageId);
  }, [asPath, pageId, getPromo]);

  if ((isLoading || isServerSide) && showLoader) {
    return <BannerHeroSkeleton />;
  }

  if (!banner) {
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return <React.Fragment />;
  }

  return (
    <BannerLandscape data={banner} removePaddingLeft={removePaddingLeft} removePaddingRight={removePaddingRight} />
  );
};
